import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-76fe598d")
const _hoisted_1 = ["stroke", "x1", "x2", "y1", "y2"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("line", {
    stroke: _ctx.line.stroke,
    x1: _ctx.line.x,
    x2: _ctx.line.x2,
    y1: _ctx.line.y,
    y2: _ctx.line.y2,
    class: "trinket-grid-line",
    "stroke-width": "1"
  }, null, 8, _hoisted_1))
}